import 'ress/dist/ress.min.css';
import { saveUtms } from './src/shared/helpers/handleUtm'

export const onClientEntry = () => {
  saveUtms();
};